// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__yulqb","imageSmall":"footer_imageSmall__ZFI-E","cltopLine":"footer_cltopLine__PjbwE"};